import Service from './Service';

export default class HsmOrganizationTypeService extends Service{
    constructor() {
        super();
        this.baseURL = 'hsmOrganizationType';
    }

}